import STATE_ONBOARDING_STEPS from '@/constants/stateOnboardingSteps';

const getStateLinks = () => {
  return Object.entries(STATE_ONBOARDING_STEPS)
    .filter(([, config]) => config.registrationUrl)
    .map(([, config]) => ({
      label: `${config.name} Provider Portal`,
      url: config.registrationUrl,
    }));
};

const providerService = {
  getStateLinks,
};

export default providerService;
